module.exports = __webpack_public_path__ + "static/media/Produce.058cca63.svg";